/* ============================================================
   ŞELALE GIDA — Shopify Tema JavaScript
   Versiyon: 1.0.0
   ============================================================ */

'use strict';

/* ── 0. PARA FORMATI (mağaza ayarını izler: "1.234,56 ₺") ── */
window.formatTL = function(cents) {
  var n = cents / 100;
  try {
    return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n) + ' ₺';
  } catch (e) {
    return n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ₺';
  }
};

/* ── 1. HERO SLIDER ──────────────────────────────────────── */
function initHeroSlider(sectionId, autoplaySpeed, autoplay) {
  var track       = document.getElementById('hero-track-' + sectionId);
  var prevBtn     = document.getElementById('hero-prev-' + sectionId);
  var nextBtn     = document.getElementById('hero-next-' + sectionId);
  var dotsWrap    = document.querySelector('#hero-' + sectionId + ' .hero-slider__dots');
  if (!track) return;

  var slides      = track.querySelectorAll('.hero-slider__slide');
  var dots        = dotsWrap ? dotsWrap.querySelectorAll('.hero-slider__dot') : [];
  var total       = slides.length;
  var current     = 0;
  var timer       = null;
  var paused      = false;

  function goTo(index) {
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach(function(d, i) {
      d.classList.toggle('hero-slider__dot--active', i === current);
      d.setAttribute('aria-selected', i === current ? 'true' : 'false');
    });
  }

  function startAuto() {
    if (!autoplay || total < 2) return;
    timer = setInterval(function() {
      if (!paused) goTo(current + 1);
    }, autoplaySpeed);
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); });
  });

  // Pause on hover
  track.addEventListener('mouseenter', function() { paused = true; });
  track.addEventListener('mouseleave', function() { paused = false; });

  // Touch / swipe
  var touchStartX = 0;
  track.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].clientX;
    paused = true;
  }, { passive: true });
  track.addEventListener('touchend', function(e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) goTo(current + (diff > 0 ? 1 : -1));
    paused = false;
  }, { passive: true });

  // Keyboard
  var sliderEl = document.getElementById('hero-' + sectionId);
  if (sliderEl) {
    sliderEl.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });
  }

  startAuto();
}

/* ── 2. ANNOUNCEMENT BAR ─────────────────────────────────── */
(function() {
  var bar = document.getElementById('announcement-bar');
  if (!bar) return;

  // Check if dismissed in session
  if (sessionStorage.getItem('announcementClosed')) {
    bar.style.display = 'none';
    return;
  }

  // Rotating slides
  var slides = bar.querySelectorAll('.announcement-bar__slide');
  if (slides.length > 1) {
    var current = 0;
    slides.forEach(function(s, i) { s.style.display = i === 0 ? 'block' : 'none'; });
    setInterval(function() {
      slides[current].style.display = 'none';
      current = (current + 1) % slides.length;
      slides[current].style.display = 'block';
    }, 4000);
  }
})();

window.closeAnnouncementBar = function() {
  var bar = document.getElementById('announcement-bar');
  if (bar) {
    bar.style.animation = 'slideUp 0.3s ease forwards';
    setTimeout(function() { bar.style.display = 'none'; }, 300);
    sessionStorage.setItem('announcementClosed', '1');
  }
};

/* ── 3. HEADER — Sticky & Scroll Effect ─────────────────── */
(function() {
  var header = document.getElementById('site-header');
  if (!header) return;

  var lastScroll = 0;

  window.addEventListener('scroll', function() {
    var scrollY = window.scrollY;

    if (scrollY > 10) {
      header.classList.add('site-header--scrolled');
    } else {
      header.classList.remove('site-header--scrolled');
    }

    lastScroll = scrollY;
  }, { passive: true });
})();

/* ── 4. MOBILE MENU ──────────────────────────────────────── */
(function() {
  var toggle  = document.getElementById('mobile-menu-toggle');
  var nav     = document.getElementById('mobile-nav');
  var close   = document.getElementById('mobile-nav-close');
  var overlay = document.getElementById('overlay');
  if (!toggle || !nav) return;

  function openMenu() {
    nav.classList.add('open');
    nav.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    nav.classList.remove('open');
    nav.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', function() {
    nav.classList.contains('open') ? closeMenu() : openMenu();
  });

  if (close)   close.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  // Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });

  // Sub-menu toggles
  var expands = nav.querySelectorAll('.mobile-nav__expand');
  expands.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var subList = btn.parentElement.querySelector('.mobile-nav__sub-list');
      if (subList) {
        var isOpen = subList.classList.contains('open');
        subList.classList.toggle('open', !isOpen);
        btn.style.transform = isOpen ? '' : 'rotate(180deg)';
      }
    });
  });
})();

/* ── 5. SEARCH TOGGLE ────────────────────────────────────── */
(function() {
  var searchToggle = document.getElementById('search-toggle');
  var searchBar    = document.getElementById('search-bar');
  var searchClose  = document.getElementById('search-close');
  if (!searchToggle || !searchBar) return;

  function openSearch() {
    searchBar.classList.add('active');
    searchBar.setAttribute('aria-hidden', 'false');
    searchToggle.setAttribute('aria-expanded', 'true');
    var input = searchBar.querySelector('.search-bar__input');
    if (input) setTimeout(function() { input.focus(); }, 100);
  }

  function closeSearch() {
    searchBar.classList.remove('active');
    searchBar.setAttribute('aria-hidden', 'true');
    searchToggle.setAttribute('aria-expanded', 'false');
  }

  searchToggle.addEventListener('click', function() {
    searchBar.classList.contains('active') ? closeSearch() : openSearch();
  });

  if (searchClose) searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSearch();
  });
})();

/* ── 6. CART — AJAX Add to Cart ─────────────────────────── */
(function() {
  var notification = document.getElementById('cart-notification');
  var cartCount    = document.getElementById('cart-count');

  function showCartNotification() {
    if (!notification) return;
    notification.classList.add('visible');
    setTimeout(function() { notification.classList.remove('visible'); }, 3500);
  }

  function updateCartCount(count) {
    if (!cartCount) return;
    cartCount.textContent = count;
    cartCount.classList.toggle('hidden', count === 0);
  }

  // Close notification
  var closeBtn = notification && notification.querySelector('.cart-notification__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      notification.classList.remove('visible');
    });
  }

  // AJAX add to cart for all quick-add forms
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.classList.contains('product-card__quick-add-form')) return;
    e.preventDefault();

    var formData = new FormData(form);
    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Ekleniyor...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      showCartNotification();
    })
    .catch(function(err) { console.error('Cart error:', err); })
    .finally(function() {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Sepete Ekle';
      }
    });
  });
})();

/* ── 7. PRODUCT TABS (Featured Products) ────────────────── */
(function() {
  var tabBtns = document.querySelectorAll('.product-tab');
  if (!tabBtns.length) return;

  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var collectionHandle = btn.dataset.collection;
      var grid = btn.closest('section').querySelector('.products-grid');
      if (!grid || !collectionHandle) return;

      // Update active tab
      btn.closest('.product-tabs').querySelectorAll('.product-tab').forEach(function(b) {
        b.classList.remove('product-tab--active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('product-tab--active');
      btn.setAttribute('aria-selected', 'true');

      // Fetch collection products
      grid.innerHTML = '<div class="products-grid__loading">Yükleniyor...</div>';

      fetch('/collections/' + collectionHandle + '/products.json?limit=8')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.products && data.products.length) {
            var html = data.products.map(function(p) {
              /* products.json fiyatı ondalık string döner ("4.56") — kuruş değil */
              var priceTL = parseFloat(p.variants[0] && p.variants[0].price) || 0;
              var priceHtml = priceTL > 0
                ? '<span class="product-card__price">' + window.formatTL(priceTL * 100) + '</span>'
                : '<a class="product-card__price product-card__price--ask" href="https://wa.me/905378550684?text=' +
                  encodeURIComponent('Merhaba, ' + p.title + ' ürününün fiyatını öğrenmek istiyorum.') +
                  '" target="_blank" rel="noopener">Fiyat için WhatsApp\'tan sorun</a>';
              return '<div class="product-card">' +
                '<div class="product-card__image-wrap">' +
                '<a href="/products/' + p.handle + '" class="product-card__image-link">' +
                (p.images[0] ? '<img src="' + p.images[0].src.replace('.jpg', '_600x.jpg') + '" alt="' + p.title + '" class="product-card__image product-card__image--primary" loading="lazy">' : '') +
                '</a></div>' +
                '<div class="product-card__info">' +
                '<h3 class="product-card__title"><a href="/products/' + p.handle + '">' + p.title + '</a></h3>' +
                '<div class="product-card__price-wrap">' +
                priceHtml +
                '</div></div></div>';
            }).join('');
            grid.innerHTML = html;
          } else {
            grid.innerHTML = '<p class="products-grid__empty">Bu kategoride ürün bulunamadı.</p>';
          }
        })
        .catch(function() {
          grid.innerHTML = '<p class="products-grid__empty">Ürünler yüklenirken hata oluştu.</p>';
        });
    });
  });
})();

/* ── 8. LAZY IMAGE OBSERVER ──────────────────────────────── */
(function() {
  if ('IntersectionObserver' in window) {
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    lazyImages.forEach(function(img) { observer.observe(img); });
  }
})();

/* ── 9. SMOOTH ANCHOR SCROLL ─────────────────────────────── */
document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
  anchor.addEventListener('click', function(e) {
    var target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

/* ── 10. DROPDOWN KEYBOARD NAV ───────────────────────────── */
(function() {
  var navItems = document.querySelectorAll('.site-nav__item--dropdown');
  navItems.forEach(function(item) {
    var trigger  = item.querySelector('.site-nav__link');
    var dropdown = item.querySelector('.site-nav__dropdown');
    if (!trigger || !dropdown) return;

    trigger.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !expanded);
        dropdown.style.visibility = expanded ? 'hidden' : 'visible';
        dropdown.style.opacity    = expanded ? '0' : '1';
      }
    });

    item.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });
  });
})();

/* ── 11. SCROLL ANIMATIONS — Fade-in & Counter ───────────── */
(function() {
  if (!('IntersectionObserver' in window)) return;

  /* --- Fade-in (fi sınıfı) --- */
  var fadeObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vis');
        fadeObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.fi').forEach(function(el, i) {
    if (!el.style.transitionDelay) {
      el.style.transitionDelay = (i % 5) * 0.08 + 's';
    }
    fadeObserver.observe(el);
  });

  /* --- Sayaç animasyonu (data-counter attribute veya about-stat-val) --- */
  function animateCounter(el) {
    var raw = el.textContent.trim();
    // Rakam, + ve K gibi suffix'leri ayır
    var match = raw.match(/^([+%]?)(\d[\d.,]*)([^0-9]*)$/);
    if (!match) return;
    var prefix  = match[1];
    var numStr  = match[2].replace(/[.,]/g, '');
    var suffix  = match[3];
    var target  = parseInt(numStr, 10);
    if (isNaN(target) || target === 0) return;

    var duration = 1400;
    var start    = null;

    function tick(now) {
      if (!start) start = now;
      var elapsed = now - start;
      var progress = Math.min(elapsed / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3); // cubic ease-out
      var current = Math.floor(ease * target);

      // Format with dots for thousands
      var formatted = current >= 1000
        ? (current / 1000).toFixed(1).replace('.', ',') + 'B'
        : current.toString();

      // Keep original format style
      if (raw.indexOf('.') > -1 || raw.indexOf('+') > -1) {
        formatted = current.toString();
      }

      el.textContent = prefix + formatted + suffix;

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = raw; // restore exact original text
      }
    }
    requestAnimationFrame(tick);
  }

  var counterObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      counterObserver.unobserve(entry.target);
      animateCounter(entry.target);
    });
  }, { threshold: 0.5 });

  // Heritage/about istatistikleri
  document.querySelectorAll('.about-stat-val').forEach(function(el) {
    counterObserver.observe(el);
  });

  // Hero stats
  document.querySelectorAll('.hero-stat-num').forEach(function(el) {
    counterObserver.observe(el);
  });

  // Brand story (toptan banner) stats
  document.querySelectorAll('.toptan-banner__stat-num').forEach(function(el) {
    counterObserver.observe(el);
  });

  /* --- Staggered section reveals --- */
  // Kategori kartları
  document.querySelectorAll('.fc-card').forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    el.style.transitionDelay = (i * 0.08) + 's';
  });

  var cardObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        cardObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.fc-card').forEach(function(el) {
    cardObserver.observe(el);
  });

  // Review kartları
  document.querySelectorAll('.review-card').forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    el.style.transitionDelay = (i * 0.12) + 's';
  });

  var reviewObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        reviewObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.review-card').forEach(function(el) {
    reviewObserver.observe(el);
  });

  // Heritage feature items
  document.querySelectorAll('.af-item').forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
    el.style.transitionDelay = (i * 0.1) + 's';
  });

  var afObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        afObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.af-item').forEach(function(el) {
    afObserver.observe(el);
  });

  // About center photo
  document.querySelectorAll('.about-center').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'scale(0.95)';
    el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    el.style.transitionDelay = '0.2s';
  });

  var centerObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'scale(1)';
        centerObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.about-center').forEach(function(el) {
    centerObserver.observe(el);
  });

  // About stats bar items
  document.querySelectorAll('.about-stat-item').forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    el.style.transitionDelay = (i * 0.1) + 's';
  });

  var statBarObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        statBarObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  document.querySelectorAll('.about-stat-item').forEach(function(el) {
    statBarObserver.observe(el);
  });

  // Hero badge / title / desc stagger (already handled inline in hero section, but add fallback)
  document.querySelectorAll('.hero-fi').forEach(function(el) {
    // already handled by hero-slider.liquid inline script
  });

  // Heritage header
  document.querySelectorAll('.heritage-header, .fp-header, .reviews-header, .fc-header').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  });

  var secHeaderObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        secHeaderObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  document.querySelectorAll('.heritage-header, .fp-header, .reviews-header, .fc-header').forEach(function(el) {
    secHeaderObserver.observe(el);
  });

  // Trust items
  document.querySelectorAll('.trust-item').forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(12px)';
    el.style.transition = 'opacity 0.45s ease, transform 0.45s ease';
    el.style.transitionDelay = (i * 0.08) + 's';
  });

  var trustObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        trustObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('.trust-item').forEach(function(el) {
    trustObserver.observe(el);
  });

  // Product cards in fp-grid
  document.querySelectorAll('.fp-card').forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    el.style.transitionDelay = (i % 4) * 0.07 + 's';
  });

  var fpCardObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        fpCardObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05 });

  document.querySelectorAll('.fp-card').forEach(function(el) {
    fpCardObserver.observe(el);
  });

})();

/* ── 11b. STAT BAR HOVER LINE EFFECT ─────────────────────── */
(function() {
  // Triggered by CSS transition, no JS needed — hover effect handled in CSS
})();

/* ── 12. KOLEKSİYON / ARAMA SAYFASI — Predictive Search ────── */
(function() {
  var input       = document.querySelector('[data-predictive-search]');
  var suggestions = document.getElementById('coll-search-suggestions');
  if (!input || !suggestions) return;

  /* ── Temizle (×) butonu ── */
  var clearBtn = document.createElement('button');
  clearBtn.type = 'button';
  clearBtn.className = 'coll-search-bar__clear';
  clearBtn.setAttribute('aria-label', 'Aramayı temizle');
  clearBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  input.parentNode.insertBefore(clearBtn, input.nextSibling);

  function updateClearBtn() {
    clearBtn.style.display = input.value.length > 0 ? 'flex' : 'none';
  }
  updateClearBtn();

  clearBtn.addEventListener('click', function() {
    input.value = '';
    input.focus();
    closeSuggestions();
    updateClearBtn();
  });

  var timer       = null;
  var lastQuery   = '';
  var activeIdx   = -1;
  var items       = [];

  function debounce(fn, ms) {
    return function() {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function() { fn.apply(null, args); }, ms);
    };
  }

  function highlight(text, query) {
    if (!query) return text;
    var re = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return text.replace(re, '<strong>$1</strong>');
  }

  function renderItems(products, query) {
    suggestions.innerHTML = '';
    activeIdx = -1;

    if (!products.length) {
      suggestions.innerHTML = '<div class="coll-suggest-empty">Sonuç bulunamadı</div>';
      suggestions.removeAttribute('hidden');
      return;
    }

    products.forEach(function(p, i) {
      var a = document.createElement('a');
      a.className = 'coll-suggest-item';
      a.href      = p.url;
      a.setAttribute('role', 'option');
      a.setAttribute('tabindex', '-1');

      var imgHtml = p.image
        ? '<img class="coll-suggest-img" src="' + p.image + '" alt="" loading="lazy" width="44" height="44">'
        : '<div class="coll-suggest-img--placeholder"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';

      a.innerHTML =
        imgHtml +
        '<div class="coll-suggest-info">' +
          '<div class="coll-suggest-title">' + highlight(p.title, query) + '</div>' +
          (p.vendor ? '<div class="coll-suggest-vendor">' + p.vendor + '</div>' : '') +
        '</div>';

      suggestions.appendChild(a);
    });

    var seeAll = document.createElement('a');
    seeAll.className = 'coll-suggest-all';
    seeAll.href      = '/search?type=product&q=' + encodeURIComponent(query);
    seeAll.textContent = '"' + query + '" için tüm sonuçları gör';
    suggestions.appendChild(seeAll);

    items = suggestions.querySelectorAll('.coll-suggest-item');
    suggestions.removeAttribute('hidden');
  }

  function closeSuggestions() {
    suggestions.setAttribute('hidden', '');
    activeIdx = -1;
    items = [];
  }

  function setActive(idx) {
    items.forEach(function(el, i) {
      el.classList.toggle('coll-suggest-item--active', i === idx);
    });
    activeIdx = idx;
  }

  var doSearch = debounce(function(q) {
    if (q === lastQuery) return;
    lastQuery = q;

    if (q.length < 2) { closeSuggestions(); return; }

    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var mapped = products.map(function(p) {
          var img = p.image ? (p.image.url || p.image) : null;
          if (img && img.indexOf('?') === -1) img += '?width=88';
          return { title: p.title, url: p.url, vendor: p.vendor, image: img };
        });
        renderItems(mapped, q);
      })
      .catch(function() { closeSuggestions(); });
  }, 280);

  input.addEventListener('input', function() {
    updateClearBtn();
    doSearch(this.value.trim());
  });

  input.addEventListener('keydown', function(e) {
    if (suggestions.hasAttribute('hidden')) return;
    var allItems = Array.from(suggestions.querySelectorAll('.coll-suggest-item, .coll-suggest-all'));
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      var next = Math.min(activeIdx + 1, allItems.length - 1);
      setActive(next);
      if (allItems[next]) allItems[next].focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (activeIdx <= 0) { input.focus(); setActive(-1); return; }
      var prev = activeIdx - 1;
      setActive(prev);
      if (allItems[prev]) allItems[prev].focus();
    } else if (e.key === 'Escape') {
      closeSuggestions();
      input.focus();
    }
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.coll-search-bar__form')) closeSuggestions();
  });

  input.addEventListener('focus', function() {
    if (this.value.trim().length >= 2 && suggestions.hasAttribute('hidden')) {
      doSearch(this.value.trim());
    }
  });
})();

/* ── 13. FREE SHIPPING PROGRESS (Sepet sayfası) ──────────── */
window.initFreeShippingBar = function(threshold, currentTotal) {
  var bar = document.querySelector('.free-shipping-bar');
  if (!bar) return;
  var remaining = threshold - currentTotal;
  var percent   = Math.min(100, Math.round((currentTotal / threshold) * 100));
  var fill = bar.querySelector('.free-shipping-bar__fill');
  var text = bar.querySelector('.free-shipping-bar__text');
  if (fill) fill.style.width = percent + '%';
  if (text) {
    text.textContent = remaining > 0
      ? window.formatTL(remaining) + ' daha ekleyin, kargo ücretsiz!'
      : '🎉 Ücretsiz kargo kazandınız!';
  }
};

/* ── 14. POLICY PAGE HERO INJECTION ──────────────────────── */
(function() {
  var isPolicy = /^\/policies\//.test(window.location.pathname) ||
                 !!document.getElementById('pol-hero-inject');
  if (!isPolicy) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  // data-title'dan veya DOM'dan başlığı al
  var injectEl = document.getElementById('pol-hero-inject');
  var originalTitle = main.querySelector('h1, h2, h3');
  var titleText = (injectEl && injectEl.dataset.title) ||
                  (originalTitle ? originalTitle.textContent.trim() : '');

  // Hero HTML oluştur
  var hero = document.createElement('div');
  hero.className = 'pol-hero';
  hero.innerHTML =
    '<div class="pol-hero__inner">' +
      '<p class="pol-hero__label">Şelale Toptan &amp; Perakende</p>' +
      '<h1 class="pol-hero__title">' + titleText + '</h1>' +
    '</div>';

  // Orijinal içeriği pol-body içine sar
  var wrapper = document.createElement('div');
  wrapper.className = 'pol-body';
  var inner = document.createElement('div');
  inner.className = 'pol-body__inner';
  var content = document.createElement('div');
  content.className = 'pol-body__content';

  // main içindeki tüm çocukları content'e taşı
  while (main.firstChild) {
    content.appendChild(main.firstChild);
  }

  inner.appendChild(content);
  wrapper.appendChild(inner);

  // Orijinal başlık zaten content içinde — gizle
  var dupTitle = content.querySelector('h1, h2, h3');
  if (dupTitle && dupTitle.textContent.trim() === titleText) {
    dupTitle.style.display = 'none';
  }

  // Hero + body'yi main'e ekle
  var pol = document.createElement('div');
  pol.className = 'pol';
  pol.appendChild(hero);
  pol.appendChild(wrapper);
  main.appendChild(pol);
})();
